if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );

  // const collapsableContents = document.querySelectorAll('.collapsable-content');
  // if (collapsableContents.length > 0) {
  //   const firstCollapsable = document.querySelector('.product__description .collapsable-content:nth-child(1)');
  //   if (firstCollapsable) {
  //     firstCollapsable.remove();
  //   }
  
  //   const newFirst = document.querySelector('.collapsable-content:nth-child(1)');
  //   if (newFirst) {
  //     newFirst.classList.add('active');
  //   }
  
  //   document.querySelectorAll('.collapsable-content h3').forEach(header => {
  //     header.addEventListener('click', function () {
  //       const parent = this.parentElement;
  
  //       // Toggle the clicked one
  //       parent.classList.toggle('active');
  
  //       // Remove "active" from siblings
  //       Array.from(parent.parentElement.children).forEach(sibling => {
  //         if (sibling !== parent && sibling.classList.contains('collapsable-content')) {
  //           sibling.classList.remove('active');
  //         }
  //       });
  //     });
  //   });
  // }
}
